import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { useBnbSelector } from "../../../redux/store";
import CarDataConsolidator from "../../../../../shared-logic/utils/classes/CarDataConsolidator";
import type { WinterWheelType } from "../../../../../../common-deprecated/types/CommonTypes";
import { removeWinterWheel } from "../../../redux/actions/BasketActions";
import { showModal } from "../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_WINTER_WHEELS } from "../../../utils/modalConstants";
import { showWinterWheel } from "../../../../../../common-deprecated/redux/actions/UtilActions";
import { trackCustomizeConfigItem, trackWinterWheelsOpen } from "../../../utils/tracking";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

type DataType = {
    activeWinterWheel: WinterWheelType | null;
    cheapestWinterWheel: WinterWheelType;
    previewImageUrl: string; // returns the wheel asset image
    openModal: () => void;
    clearSelectedWheel: () => void;
};

const useWinterWheelsPanel = (): DataType => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const activeWinterWheel = useBnbSelector((state) => state.basket.winterWheel);
    const winterWheels = useBnbSelector((state) =>
        CarDataConsolidator.getWinterWheels(state.items.winterWheels, state.basket.colour, state.basket.upholstery),
    );

    const openModal = (): void => {
        trackWinterWheelsOpen();
        dispatch(
            showModal({
                type: MODAL_WINTER_WHEELS,
            }),
        );
    };

    const clearSelectedWheel = (): void => {
        trackCustomizeConfigItem(NavStep.Customize, "remove-winter-set");
        dispatch(removeWinterWheel());
        dispatch(showWinterWheel(false));
    };

    return {
        activeWinterWheel,
        cheapestWinterWheel: winterWheels[0],
        previewImageUrl: (activeWinterWheel || winterWheels[0]).image,
        openModal,
        clearSelectedWheel,
    };
};

export default useWinterWheelsPanel;
